import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
export interface ModalState {
  id: string | null;
  data?: any;
}

export interface GlobalState {
  sidebarOpen: boolean;
  modalOpen: ModalState;
  permissions?: string[];
  // The Topbar's subtitle (e.g. "412 applications · 87 awaiting first
  // review") is page-specific dynamic data — a page sets it, PostLogin's
  // Topbar reads it. Redux is the cross-cutting-UI-state mechanism this
  // app already uses (see `sidebarOpen`), so this reuses it rather than
  // introducing a separate Context just for one value.
  pageSubtitle: string | null;
  pageTitle: string | null;
}

const initialModalOpen: ModalState = {
  id: null,
  data: null,
};

const initialState: GlobalState = {
  sidebarOpen: true,
  modalOpen: initialModalOpen,
  permissions: [],
  pageSubtitle: null,
  pageTitle: null,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
    setModalOpen: (state, action: PayloadAction<ModalState | null>) => {
      state.modalOpen = action.payload || initialModalOpen;
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
    },
    setPageSubtitle: (state, action: PayloadAction<string | null>) => {
      state.pageSubtitle = action.payload;
    },
    setPageTitle: (state, action: PayloadAction<string | null>) => {
      state.pageTitle = action.payload;
    },
    clear: () => initialState,
  },
});

export default globalSlice.reducer;
export const { setPermissions, setModalOpen, setSidebarOpen, setPageSubtitle, setPageTitle, clear } =
  globalSlice.actions;
